export const initView = ({ formCssPath, contentCssPath, cssPathToElemBehaviorOpenForm }) => ({
  showForm: () => {
    $(formCssPath).show();
    $(contentCssPath).hide();
  },
  showContent: () => {
    $(formCssPath).hide();
    $(contentCssPath).show();
  },
  onTriggerNew: (cb) => {
    $(document).on('click', cssPathToElemBehaviorOpenForm, () => cb());
  },
});

export const initTable = ({ tableCssPath, prepareColumns = () => [] }) => {
  function onTriggerEdit(cb) {
    $(tableCssPath).on('click', '.behavior-edit-item', (e) => cb(e.target.dataset.id));
  }

  function onTriggerRemove(cb) {
    $(tableCssPath).on('click', '.behavior-remove-item', (e) => cb(e.target.dataset.id));
  }

  function set(itemsData) {
    const elements = itemsData.reduce((acc, item) => acc + htmlTemplate(item), '');
    $(`${tableCssPath} tbody`).html(elements);

    if (itemsData.length > 0) {
      $(tableCssPath).show();
    } else {
      $(tableCssPath).hide();
    }
  }

  function add(itemData) {
    const previousData = getData();
    const $body = $(`${tableCssPath} tbody`);
    const newRow = htmlTemplate(itemData);
    $body.prepend(newRow);
    if (previousData.length === 0) {
      $(tableCssPath).show();
    }
  }

  function update(itemData) {
    const $row = $(`tr[data-id="${itemData.id}"]`);
    $row.replaceWith(htmlTemplate(itemData));
  }

  function map(cb) {
    return set(getData().map(cb));
  }

  function remove(id) {
    $(`tr[data-id="${id}"]`).remove();
    if (getData().length === 0) {
      $(tableCssPath).hide();
    }
  }

  function getData() {
    const items = [];
    $(`${tableCssPath} tbody tr`).each((index, element) => {
      const itemData = $(element).attr('data-info');
      items.push(JSON.parse(itemData));
    });
    return items;
  }

  function htmlTemplate(item = {}) {
    const columns = prepareColumns(item).reduce((acc, column) => `${acc}<td>${column}</td>`, '');

    return `
      <tr data-id="${item.id}" data-info='${JSON.stringify(item)}'>
        ${columns}
        <td>
          <button 
            type="button" 
            class="btn btn-primary btn-sm btn-no-point-event-icon behavior-edit-item" 
            data-id="${item.id}"
          >
            <i class="fas fa-pen"></i>
          </button>
          <button 
            type="button" 
            class="btn btn-danger btn-sm btn-no-point-event-icon behavior-remove-item" 
            data-id="${item.id}"
          >
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
   `;
  }

  return {
    onTriggerEdit,
    onTriggerRemove,
    set,
    add,
    update,
    remove,
    map,
    getData,
  };
};
